import BaseComponent from "../../../baseComponent.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import "!style!css!../../../../vendors/rangeslider-1.1.0.css";
import styles from "./style.scss";

export default class GlobeComponent extends BaseComponent {
  constructor(props) {
    super(props);
    this.number = 0;
  }

  componentDidMount() {
    var that = this;
    var dataPointsLength = 57;
    var container = document.getElementById('globe-container');
    that.globe = new Globe.Bar(container);

    var i, tweens = [];

    var settime = function (globe, t) {
      return function () {
        new TWEEN.Tween(globe).to({time: t / dataPointsLength}, 500).easing(TWEEN.Easing.Cubic.EaseOut).start();
      };
    };

    this.subscribe("crude-oil-time-changed", function (timeIndex) {
      settime(that.globe, timeIndex)();
    });

    var xhr;
    TWEEN.start();


    xhr = new XMLHttpRequest();
    xhr.open('GET', 'resources/globe/crudeoil.json', true);
    xhr.onreadystatechange = function (e) {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          let data = xhr.responseText.replace("module.exports = ", "");
          data = JSON.parse(data);
          window.data = data;
          for (i = 0; i < data.length; i++) {
            that.globe.addData(data[i][1], {format: 'magnitude', name: data[i][0], animated: true});
          }
          that.globe.createPoints();
          settime(that.globe, 0)();
          that.globe.animate();
          document.body.style.backgroundImage = 'none'; // remove loading
        }
      }
    };
    xhr.send(null);

    this.publish(InternalEvent.App.HIDE_PRELOADER);
  }



  componentWillUnmount() {
    this.globe.dispose();
    this.unsubscribeAll();
  }

  render() {
    var style = {
      width: '100vw',
      height: '80vh'
    }

    return (
      <div id="globe-container" style={style}></div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/globe/crude-oil/globe.jsx